import { ButtonGroup } from 'react-bootstrap';
import { useSlate } from 'slate-react';
import { Editor, Transforms, Element as SlateElement } from 'slate';
import { ButtonConfig } from '@victorequena22/component-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React, { useCallback } from 'react';
var getProp = function (n, prop) { return n[prop]; };
var setProps = function (editor, prop, value) {
    var _a;
    return Transforms.setNodes(editor, (_a = {}, _a[prop] = value, _a));
};
var setPropsOrRemove = function (editor, prop, value) {
    var _a;
    return Transforms.setNodes(editor, (_a = {}, _a[prop] = isBlockProps(editor, prop, value) ? 'paragraph' : value, _a));
};
var getMatch = function (a, b) {
    var c = Editor.nodes(a, b);
    return c;
};
export var getTabs = function (editor) {
    for (var i = 0; i < 10; i++)
        if (isBlockProps(editor, 'tabs', i))
            return i;
    return 0;
};
export var setTabs = function (editor, i) { return setProps(editor, 'tabs', i < 0 ? 0 : i > 9 ? 9 : i); };
export var isBlockProps = function (editor, prop, value) {
    var selection = editor.selection;
    if (!selection)
        return false;
    var match = Array.from(getMatch(editor, {
        at: Editor.unhangRange(editor, selection),
        match: function (n) { return !Editor.isEditor(n) && SlateElement.isElement(n) && getProp(n, prop) === value; }
    }))[0];
    if (match)
        console.log(match, match);
    return match && (match.length > 0);
};
//block menus
export var TabsMenu = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b;
    var editor = useSlate();
    var tabs = getTabs(editor);
    return (React.createElement(ButtonGroup, { className: "ml-".concat(left) },
        React.createElement(ButtonConfig, { tip: 'TABULAR TEXTO A LA IZQUIERDA', icon: 'fas fa-angle-left', action: function () { return setTabs(editor, tabs - 1); } }),
        React.createElement(ButtonConfig, { tip: 'TABULAR TEXTO A LA DERECHA', icon: 'fas fa-angle-right', action: function () { return setTabs(editor, tabs + 1); } })));
};
export var AlingMenu = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b;
    var editor = useSlate();
    var val = useCallback(function (e) { return isBlockProps(editor, 'align', e); }, [editor]);
    var set = useCallback(function (e) { return setProps(editor, 'align', e); }, [editor]);
    return (React.createElement(ButtonGroup, { className: "ml-".concat(left) },
        React.createElement(ButtonConfig, { tip: 'ALINEAR TEXTO A LA IZQUIERDA', icon: 'fas fa-align-left', active: val('left'), action: function () { return set('left'); } }),
        React.createElement(ButtonConfig, { tip: 'CENTRAR TEXTO', icon: 'fas fa-align-center', active: val('center'), action: function () { return set('center'); } }),
        React.createElement(ButtonConfig, { tip: 'ALINEAR TEXTO A LA DERECHA', icon: 'fas fa-align-right', active: val('right'), action: function () { return set('right'); } }),
        React.createElement(ButtonConfig, { tip: 'JUSTIFICAR TEXTO', icon: 'fas fa-align-justify', active: val('justify'), action: function () { return set('justify'); } })));
};
export var TypeMenu = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b;
    var editor = useSlate();
    var val = useCallback(function (e) { return isBlockProps(editor, 'type', e); }, [editor]);
    var set = useCallback(function (e) { return setPropsOrRemove(editor, 'type', e); }, [editor]);
    return (React.createElement(ButtonGroup, { className: "ml-".concat(left) },
        React.createElement(ButtonConfig, { tip: 'TITULO 1', icon: 'fas fa-heading', active: val('heading-one'), action: function () { return set('heading-one'); } }),
        React.createElement(ButtonConfig, { tip: 'TITULO 2', icon: 'fas fa-h1', active: val('heading-two'), action: function () { return set('heading-two'); } }),
        React.createElement(ButtonConfig, { tip: 'TITULO 3', icon: 'fas fa-h2', active: val('heading-tre'), action: function () { return set('heading-tre'); } }),
        React.createElement(ButtonConfig, { tip: 'TITULO 4', icon: 'fas fa-h3', active: val('heading-for'), action: function () { return set('heading-for'); } })));
};
export var ListMenu = function (_a) {
    var _b = _a.left, left = _b === void 0 ? 2 : _b;
    var editor = useSlate();
    var val = useCallback(function (e) { return isBlockProps(editor, 'list', e); }, [editor]);
    var set = useCallback(function (e) { return setPropsOrRemove(editor, 'list', e); }, [editor]);
    return (React.createElement(ButtonGroup, { className: "ml-".concat(left) },
        React.createElement(ButtonConfig, { tip: 'LISTA CON PUNTOS', icon: 'fas fa-list-ul', active: val('bulleted-list'), action: function () { return set('bulleted-list'); } }),
        React.createElement(ButtonConfig, { tip: 'LISTA CON CUADROS', icon: 'fas fa-list', active: val('list-item'), action: function () { return set('list-item'); } })));
};
//# sourceMappingURL=BlockProps.js.map